<div class="relative flex h-full flex-col gap-8 py-5">
  <pl-icon
    [frame]="IconFrame.round"
    [name]="PlIcon.close"
    (click)="closeModal()"
    class="absolute right-2 top-2 z-10 h-12 w-12 cursor-pointer border-transparent bg-transparent text-pl-gray-700 hover:bg-pl-gray-200"
  />
  <div class="flex grow flex-col overflow-auto px-5">
    <h2 class="mb-4 font-sans text-pl-gray-500">
      {{ 'lifemap.override_event_modal.title' | translate }}
    </h2>

    <p class="text-lg">{{ 'lifemap.override_event_modal.body' | translate }}</p>
    <div class="ml-6 text-lg text-pl-gray-450">
      <div *ngFor="let event of eventsOverriddenAsString()" class="list-item list-disc">
        <div class="flex items-center gap-1">
          <p class="shrink-0">{{ event.dateTime }} |</p>
          <pl-icon class="h-4 w-4 min-w-[1rem]" [name]="event.icon" />
          <p class="shrink-0">{{ 'lifemap.category.' + event.type | translate }}</p>
          <p *ngIf="!!event.title" class="truncate">| {{ event.title }}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="flex justify-end gap-4 px-5">
    <pl-button class="!w-fit" [padding]="ButtonPadding.big" [variant]="ButtonVariant.white" (click)="closeModal()">
      {{ 'utils.cancel' | translate }}
    </pl-button>
    <pl-button
      class="!w-fit min-w-[100px]"
      [padding]="ButtonPadding.big"
      [variant]="ButtonVariant.lightOrange"
      (click)="overrideEvent()"
    >
      {{ 'utils.ok' | translate }}
    </pl-button>
  </div>
</div>
